import PropTypes from 'prop-types'

import InputLabel from '../ui/InputLabel'
import Upload from './Upload'

const AgregarFotos = ({ value, onChange, idPublicacion, idPublicacionTemporal }) => {
  return (
    <>
      <p className="descripcion-cuadro-publicacion">Maximo 5 fotos</p>
      <Upload
        accept={{ 'image/*': [] }}
        idPublicacion={idPublicacion}
        idPublicacionTemporal={idPublicacionTemporal}
      />
      <div className="row">
        <div className="col text-center mt-4">
          <InputLabel
            name="youtube"
            value={value}
            onChange={onChange}
            label={
              <>
                Link video YouTube:
                <span className="yt-logo ml-2">
                  <i className="fa fa-youtube-play" aria-hidden="true" />
                </span>
              </>
            }
            classNameLabel=""
            classNameInput="link-youtube"
            placeholder=""
          />
        </div>
      </div>
    </>
  )
}

AgregarFotos.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  idPublicacion: PropTypes.number,
  idPublicacionTemporal: PropTypes.number
}

export default AgregarFotos
